export const authentication = {
  confirmEmail: {
    anActivationEmailHasBeenSent: 'Aktivacijski link je poslan, molimo potvrdite svoj email',
    weHaveSentActivationLinkToEmailAddress: `Poslali smo aktivacijski link na email adresu`,
    toVerifyYourAccount: `za 'Verifikaciju vašeg računa'.`,
    onceVerifiedAutomaticallyRedirected: 'Nakon verifikacije, bit ćete automatski preusmjereni na panel.',
    didNotReceiveAnEmail: `Niste primili email? Provjerite svoj spam folder`,
    resendIn: 'Ponovno pošalji za ',
    seconds: ' sekundi',
    resend: 'Ponovno pošalji',
    backToSignUp: 'Natrag na Prijavu',
    greatPleaseCheckYourMessage: 'Odlično, molimo provjerite svoj email',
    weHaveSentEmailTo: `Poslali smo email na`,
    withALinkToReset: ` s poveznicom za resetiranje računa. Kada se aktivira, moći ćete završiti kreiranje računa i započeti besplatno probno razdoblje.`,
    resent: 'Ponovno poslano',
    backToLogin: 'Natrag na Prijavu',
  },
  forgotPassword: {
    forgotPassword: 'Zaboravljena lozinka?',
    noWorries: 'Bez brige,',
    weWillSendYouResetPasswordInstructions: `poslat ćemo vam upute za resetiranje lozinke`,
    workEmail: 'Poslovni Email',
    continue: 'Nastavi',
    backToLogin: 'Natrag na Prijavu',
    placeholders: {
      enterYourEmail: 'Unesite svoj email',
    }
  },
  logout: {
    logout: 'Odjava',
    wantToLogOut: 'Jeste li sigurni da želite odjaviti?',
    yesIWillBeBack: `Da, vratiću se`,
    cancel: 'Odustani',
  },
  newPassword: {
    createNewPassword: 'Stvorite novu lozinku',
    yourNewPasswordMustBeDifferent: 'Nova lozinka mora biti različita od prethodno korištenih lozinki.',
    password: 'Lozinka',
    confirmPassword: 'Potvrdi lozinku',
    setPassword: 'Postavi lozinku',
    signUp: 'Prijavi se',
    login: 'Prijava',
    backTo: 'Natrag na ',
    setAPassword: 'Postavite lozinku',
    setNewPasswordToYourAccount: 'Postavite novu lozinku na svoj račun iz sigurnosnih i privatnosti razloga',
    backToSignUp: 'Natrag na Prijavu',
    placeholders: {
      enterYourPassword: 'Unesite svoju lozinku',
    }
  },
  resetPassword: {
    passwordReset: 'Resetiranje lozinke',
    yourPasswordHasBeenSuccessfullyReset: 'Vaša lozinka je uspješno resetirana.',
    clickBelowToLogIn: 'Kliknite ispod kako biste se prijavili',
    continueToLogin: 'Nastavi s prijavom',
  },
  newSignUp: {
    welcomeBack: 'Dobrodošli natrag ',
    to: 'na',
    logIn: 'Prijava ',
    as: 'kao ',
    withFacebook: 's Facebookom',
    logInWithGoogle: 'Prijavi se putem Googlea',
    or: 'ILI',
    pleaseFillAValidWorkEmail: 'Molimo popunite ispravnu radnu email adresu*',
    workEmailIsRequired: 'Radna email adresa je obavezna*',
    pleaseFillAValidPassword: 'Molimo unesite ispravnu lozinku*',
    passwordIsRequired: 'Lozinka je obavezna*',
    rememberMe: 'Zapamti me',
    forgotPassword: 'Zaboravljena lozinka?',
    login: 'Prijava',
    doNotHaveAnAccount: `Nemate račun?`,
    setUpAFreeAccount: 'Postavite BESPLATAN račun',
    noCreditCardRequired: 'Nema potrebe za kreditnom karticom',
    cancelAnytime: 'Otkažite bilo kada',
    signUp: 'Prijavite se ',
    // as: 'kao ',
    // withFacebook: 's Facebookom',
    signUpWithGoogle: 'Prijavite se putem Googlea',
    // or: 'ILI',
    emailIsAlreadyRegistered: 'Email je već registriran kod nas, molimo kliknite na Prijavu kako biste nastavili',
    phoneNumberShouldHaveMinimum7Digits: 'Broj telefona treba imati najmanje 7 znamenki*',
    phoneNumberIsRequired: 'Broj telefona je obavezan*',
    passwordMustContain: 'Lozinka mora sadržavati',
    atleast6Characters: 'najmanje 6 znakova, ',
    oneUpperCaseLetter: '1 veliko slovo ',
    oneSpecialCharacter: '1 poseban znak*',
    alreadyHaveAccount: 'Već imate račun?',
    signingUpToBotPenguinIsAConsentToOur: 'Prijavom za BotPenguin račun pristajete naše ',
    privacyPolicy: 'Politike privatnosti',
    termsAndConditions: 'Uvjete korištenja',
    and: ' i ',
    english: 'Engleski',
    hindi: 'Hindski',
    german: 'Njemački',
    french: 'Francuski',
    portuguese: 'Portugalski',
    spanish: 'Španjolski',
    italian: 'Talijanski',
    russian: 'Ruski',
    placeholders: {
      workEmail: 'Radna Email adresa*',
      password: 'Lozinka*',
      phone: 'Telefon*',
    }
  },
  unsubscribe: {
    successfullyUnsubscribed: 'Uspješno odjavljeno',
    yourEmail: 'Vaš email ',
    haveBeenSuccessfullyUnsubscribedFrom: ' uspješno je odjavljen iz',
    backToLogin: 'Natrag na Prijavu'
  }
};

